import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";

// this will enable HMR for custom handlers
/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainBefore(chain, PopulateApiParameter, props => {
    const deleteShipToProps = props;
    deleteShipToProps.parameter.shipTo.properties = { "isArchived": props.parameter.additionalQueryStringParameters?.canDelete };

    props.apiParameter = deleteShipToProps.parameter;
});
